(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amb-about"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const btn = event.target instanceof Element ? event.target.closest('[data-amb-about-sound]') : null;
    if (!btn) return;
    const video = btn.parentElement.querySelector('video');
    if (!video) return;
    const on = btn.getAttribute('aria-pressed') !== 'true';
    video.muted = !on;
    if (on) { video.currentTime = 0; video.play().catch(() => {}); }
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    const label = btn.querySelector('[data-amb-about-sound-label]');
    if (label) label.textContent = on ? 'Sound off' : 'Sound on';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amb-apps"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var API = 'https://api.okendo.io/v1/stores/';
    // Same zipper colors as the homepage review cards.
    var ZIP = [
      [/leafy|green|lettuce/i, '#4a7a3c'],
      [/veg/i, '#e2562b'],
      [/berr/i, '#4a63c9'],
      [/mush/i, '#e3b22a']
    ];
    function zipFor(name) {
      for (var i = 0; i < ZIP.length; i++) if (ZIP[i][0].test(name || '')) return ZIP[i][1];
      return 'var(--amb-orange)';
    }
    function el(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text != null) n.textContent = text;
      return n;
    }
    function customerPhoto(r) {
      var m = (r.media || []).find(function (x) { return x && (x.type === 'image' || !x.type) && (x.largeUrl || x.fullSizeUrl || x.thumbnailUrl); });
      return m ? (m.largeUrl || m.fullSizeUrl || m.thumbnailUrl) : '';
    }

    function card(r, root, src) {
      var product = r.productName || root.dataset.name || '';
      var li = el('li', 'amb-rcard amb-linen');
      li.style.setProperty('--zip', zipFor(product));

      var body = el('div', 'amb-rcard__body');
      var stars = el('p', 'amb-rcard__stars');
      stars.setAttribute('aria-label', r.rating + ' out of 5 stars');
      for (var i = 0; i < r.rating; i++) { var st = el('span', 'amb-rating__star'); st.setAttribute('aria-hidden', 'true'); stars.appendChild(st); }
      body.appendChild(stars);

      var q = el('blockquote', 'amb-rcard__quote');
      q.appendChild(el('p', null, '\u201C' + String(r.body).trim() + '\u201D'));
      body.appendChild(q);

      var who = el('p', 'amb-rcard__who');
      who.appendChild(el('span', 'amb-rcard__name', '\u2013 ' + ((r.reviewer && r.reviewer.displayName) || 'Customer')));
      if (r.reviewer && r.reviewer.isVerified) who.appendChild(el('span', 'amb-rcard__badge', 'Verified'));
      body.appendChild(who);

      if (product) {
        var tag = el(r.productUrl ? 'a' : 'p', 'amb-rcard__bag');
        if (r.productUrl) tag.href = r.productUrl;
        var dot = el('span', 'amb-rcard__dot'); dot.setAttribute('aria-hidden', 'true');
        tag.appendChild(dot);
        tag.appendChild(document.createTextNode(product));
        body.appendChild(tag);
      }
      li.appendChild(body);

      if (src) {
        var media = el('div', 'amb-rcard__media');
        var img = el('img');
        img.src = src; img.alt = ''; img.loading = 'lazy'; img.decoding = 'async';
        media.appendChild(img);
        li.appendChild(media);
      } else {
        li.classList.add('amb-rcard--text');
      }
      return li;
    }

    // One photo per card: the customer's own first, then a different photo
    // of the bags for each remaining card.
    function photos(list, root) {
      var pool = (root.dataset.pool || '').split('|').map(function (u) { return u.trim(); }).filter(Boolean);
      var used = {};
      list.forEach(function (r) { var c = customerPhoto(r); if (c) used[c] = true; });
      pool = pool.filter(function (u, i) { return pool.indexOf(u) === i && !used[u]; });
      var next = 0;
      return list.map(function (r) {
        var c = customerPhoto(r);
        if (c) return c;
        if (!pool.length) return r.productImageUrl || root.dataset.image || '';
        var u = pool[next % pool.length];
        next++;
        return u;
      });
    }

    function good(list) {
      return (list || []).filter(function (r) { return r && r.rating >= 4 && r.body; });
    }
    function get(url) {
      return fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.ok ? res.json() : { reviews: [] }; })
        .then(function (json) { return good(json.reviews); })
        .catch(function () { return []; });
    }

    function arrows(root) {
      var rail = root.querySelector('[data-amb-reviews-rail]');
      var box = root.querySelector('[data-amb-reviews-arrows]');
      var prev = root.querySelector('[data-amb-reviews-prev]');
      var next = root.querySelector('[data-amb-reviews-next]');
      if (!rail || !box) return;
      function step() {
        var c = rail.querySelector('.amb-rcard');
        var gap = parseFloat(getComputedStyle(rail).columnGap) || 16;
        return c ? c.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
      }
      function sync() {
        var max = rail.scrollWidth - rail.clientWidth - 2;
        prev.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= max;
        box.hidden = max <= 0;
      }
      prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
      rail.addEventListener('scroll', function () { requestAnimationFrame(sync); }, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    }

    function fill(root) {
      var sub = root.dataset.sub;
      var rail = root.querySelector('[data-amb-reviews-rail]');
      if (!sub || !rail) return;
      var q = '/reviews?limit=12&orderBy=' + encodeURIComponent('rating desc');
      get(API + sub + '/products/' + root.dataset.product + q).then(function (mine) {
        if (mine.length >= 3) return mine;
        return get(API + sub + q).then(function (all) {
          var seen = {};
          mine.forEach(function (r) { seen[r.reviewId] = true; });
          return mine.concat(all.filter(function (r) { return !seen[r.reviewId]; }));
        });
      }).then(function (list) {
        list = list.slice(0, 10);
        if (!list.length) return;
        var srcs = photos(list, root);
        rail.replaceChildren.apply(rail, list.map(function (r, i) { return card(r, root, srcs[i]); }));
        rail.hidden = false;
        arrows(root);
      });
    }

    function openAll(root, open) {
      var panel = root.querySelector('[data-amb-reviews-all]');
      var btn = root.querySelector('[data-amb-reviews-toggle]');
      var label = root.querySelector('[data-amb-reviews-label]');
      if (!panel || !btn) return;
      if (!label.dataset.idle) label.dataset.idle = label.textContent;
      panel.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      label.textContent = open ? 'Hide Reviews' : label.dataset.idle;
      if (open) window.dispatchEvent(new Event('resize'));
    }

    function init(root) {
      if (root.dataset.ambBooted === 'true') return;
      root.dataset.ambBooted = 'true';
      fill(root);

      var btn = root.querySelector('[data-amb-reviews-toggle]');
      if (btn) btn.addEventListener('click', function () {
        openAll(root, btn.getAttribute('aria-expanded') !== 'true');
      });

      var write = root.querySelector('[data-amb-reviews-write]');
      if (write) write.addEventListener('click', function () {
        openAll(root, true);
        var panel = root.querySelector('[data-amb-reviews-all]');
        var tries = 0;
        (function look() {
          var target = Array.prototype.find.call(panel.querySelectorAll('button, a'), function (n) {
            return /write a review/i.test(n.textContent || '');
          });
          if (target) { target.click(); return; }
          if (++tries < 20) setTimeout(look, 150);
          else panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        })();
      });
    }

    function boot() { document.querySelectorAll('[data-amb-reviews]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amb-bignum"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const fmt = new Intl.NumberFormat('en-US');
    const run = (root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      const el = root.querySelector('[data-to]');
      const to = el ? parseFloat(el.dataset.to) : NaN;
      if (!el || !isFinite(to) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const go = () => {
        const start = performance.now();
        const tick = (t) => {
          const p = Math.min(1, (t - start) / 2600);
          el.textContent = fmt.format(Math.round(to * (1 - Math.pow(1 - p, 4))));
          if (p < 1) requestAnimationFrame(tick);
        };
        el.textContent = '0';
        requestAnimationFrame(tick);
      };
      if (!('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver((entries) => entries.forEach((e) => {
        if (e.isIntersecting) { io.disconnect(); go(); }
      }), { threshold: 0.4 });
      io.observe(root);
    };
    const boot = () => document.querySelectorAll('[data-amb-bignum]').forEach(run);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amb-blog"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-amb-blog]');
    if (!root) return;

    // Load more: fetch the next page and append its cards in place.
    const grid = root.querySelector('[data-amb-blog-grid]');
    const next = root.querySelector('[data-amb-blog-next]');
    const shown = root.querySelector('[data-amb-blog-shown]');
    if (grid && next) {
      next.addEventListener('click', async (event) => {
        event.preventDefault();
        const url = next.getAttribute('href');
        if (!url || next.dataset.busy) return;
        next.dataset.busy = 'true';
        next.textContent = 'Loading';
        try {
          const html = await (await fetch(url, { credentials: 'same-origin' })).text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          doc.querySelectorAll('[data-amb-blog-grid] > li').forEach((li) => grid.appendChild(li));
          const nextLink = doc.querySelector('[data-amb-blog-next]');
          if (shown) shown.textContent = grid.children.length;
          if (nextLink) {
            next.setAttribute('href', nextLink.getAttribute('href'));
            next.textContent = 'Load more stories';
            delete next.dataset.busy;
          } else {
            next.closest('.amb-blog__more').remove();
          }
        } catch (e) {
          window.location.href = url;
        }
      });
    }

    // Search as you type, using Shopify predictive search for articles.
    const form = root.querySelector('[data-amb-blog-search]');
    const input = root.querySelector('[data-amb-blog-q]');
    const box = root.querySelector('[data-amb-blog-results]');
    if (!form || !input || !box) return;
    let timer = null;
    let last = '';
    const esc = (str) => String(str).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

    async function run(q) {
      if (q.length < 2) { box.hidden = true; box.innerHTML = ''; return; }
      last = q;
      try {
        const params = new URLSearchParams({ q, 'resources[type]': 'article', 'resources[limit]': '6' });
        const res = await fetch(`${window.Shopify?.routes?.root || '/'}search/suggest.json?${params}`, { headers: { Accept: 'application/json' } });
        const json = await res.json();
        if (q !== last) return;
        const items = json?.resources?.results?.articles || [];
        if (!items.length) {
          box.innerHTML = `<p class="amb-blog__none">No stories match “${esc(q)}”.</p>`;
        } else {
          box.innerHTML = '<ul role="list">' + items.map((a) => `
            <li><a href="${esc(a.url)}">
              ${a.image ? `<img src="${esc(a.image)}&width=160" alt="" width="64" height="48" loading="lazy">` : '<span class="amb-blog__noimg"></span>'}
              <span>${esc(a.title)}</span>
            </a></li>`).join('') + `</ul><a class="amb-blog__all" href="${form.action}?type=article&q=${encodeURIComponent(q)}">See all results</a>`;
        }
        box.hidden = false;
      } catch (e) { box.hidden = true; }
    }

    input.addEventListener('input', () => {
      clearTimeout(timer);
      timer = setTimeout(() => run(input.value.trim()), 220);
    });
    input.addEventListener('keydown', (e) => { if (e.key === 'Escape') { box.hidden = true; input.blur(); } });
    document.addEventListener('click', (e) => { if (!form.contains(e.target)) box.hidden = true; });
    input.addEventListener('focus', () => { if (box.innerHTML) box.hidden = false; });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amb-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const btn = event.target instanceof Element ? event.target.closest('[data-amb-filter]') : null;
    if (!btn) return;
    const root = btn.closest('[data-amb-collection]');
    if (!root) return;
    const value = btn.dataset.ambFilter;
    root.querySelectorAll('[data-amb-filter]').forEach((b) => b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'));
    let shown = 0;
    root.querySelectorAll('.amb-card').forEach((card) => {
      const group = card.dataset.mode;
      const match = value === 'all' || group === value || (group === 'set' && (value === 'damp' || value === 'dry'));
      card.hidden = !match;
      if (match) shown++;
    });
    const count = root.querySelector('[data-amb-count]');
    if (count) count.textContent = `${shown} ${shown === 1 ? 'product' : 'products'}`;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amb-feature"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Impact counter: each figure counts up from zero the first time the
    // counter scrolls into view, one after another.
    const fmt = new Intl.NumberFormat('en-US');
    const run = (root) => {
      if (root.dataset.ambCounted) return;
      root.dataset.ambCounted = '1';
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      root.querySelectorAll('[data-to]').forEach((el, i) => {
        const to = parseFloat(el.dataset.to);
        if (!isFinite(to) || reduce) return;
        const dec = (el.dataset.to.split('.')[1] || '').length;
        el.textContent = '0';
        const start = performance.now() + i * 180;
        const dur = 1800;
        const tick = (t) => {
          const p = Math.min(1, Math.max(0, (t - start) / dur));
          const e = 1 - Math.pow(1 - p, 4);
          el.textContent = dec ? (to * e).toFixed(dec) : fmt.format(Math.round(to * e));
          if (p < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      });
      root.classList.add('is-in');
    };
    const boot = () => {
      const els = document.querySelectorAll('[data-amb-impact]:not([data-amb-counted])');
      if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
      const io = new IntersectionObserver((entries) => entries.forEach((e) => {
        if (e.isIntersecting) { io.unobserve(e.target); run(e.target); }
      }), { threshold: 0.4 });
      els.forEach((el) => io.observe(el));
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amb-impact"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Facts count up (keeping any $, %, M or words around the number) and the
    // statement fades in, the first time each scrolls into view.
    const count = (el, delay) => {
      const raw = el.textContent.trim();
      const m = raw.match(/^(\D*?)([\d,.]+)(.*)$/);
      if (!m || /\d/.test(m[3])) return;
      const to = parseFloat(m[2].replace(/,/g, ''));
      if (!isFinite(to)) return;
      const dec = (m[2].split('.')[1] || '').length;
      const fmt = new Intl.NumberFormat('en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec });
      const start = performance.now() + delay;
      const tick = (t) => {
        const p = Math.min(1, Math.max(0, (t - start) / 1600));
        const e = 1 - Math.pow(1 - p, 4);
        el.textContent = m[1] + fmt.format(to * e) + m[3];
        if (p < 1) requestAnimationFrame(tick);
      };
      el.textContent = m[1] + fmt.format(0) + m[3];
      requestAnimationFrame(tick);
    };
    const setup = (root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const targets = root.querySelectorAll('[data-amb-imp-facts], [data-amb-imp-reveal]');
      if (!('IntersectionObserver' in window)) { targets.forEach((t) => t.classList.add('is-in')); return; }
      root.classList.add('is-armed');
      const io = new IntersectionObserver((entries) => entries.forEach((e) => {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        e.target.classList.add('is-in');
        if (!reduce && e.target.matches('[data-amb-imp-facts]')) {
          e.target.querySelectorAll('[data-amb-imp-num]').forEach((n, i) => count(n, 250 + i * 160));
        }
      }), { threshold: 0.3 });
      targets.forEach((t) => io.observe(t));
    };
    const boot = () => document.querySelectorAll('[data-amb-imp]').forEach(setup);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amb-locator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-amb-locator]');
    if (!root || root.dataset.ambBooted) return;
    root.dataset.ambBooted = '1';

    const $ = (sel) => root.querySelector(sel);
    const listEl = $('[data-amb-loc-list]');
    const statusEl = $('[data-amb-loc-status]');
    const mapEl = $('[data-amb-loc-map]');
    const form = $('[data-amb-loc-form]');
    const input = $('[data-amb-loc-q]');
    const nearBtn = $('[data-amb-loc-near]');
    const resetBtn = $('[data-amb-loc-reset]');
    const stateSel = $('[data-amb-loc-chips]');
    const totalEl = $('[data-amb-loc-total]');
    const statesEl = $('[data-amb-loc-states]');
    const hintEl = $('[data-amb-loc-hint]');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Shops number from the section settings (e.g. "190+"). When set, the map's
    // list is labeled as the shops on the map rather than all shops.
    const fixedTotal = (root.dataset.total || '').trim();
    const fixedNum = parseInt(fixedTotal.replace(/[^0-9]/g, ''), 10) || 0;

    // The four bag zipper colors: Leafy Greens, Vegetable, Berry, Mushroom.
    const PALETTE = ['#4a7a3c', '#dd6729', '#4a63c9', '#d9a21f'];
    const STATES = { AL: 'Alabama', AK: 'Alaska', AZ: 'Arizona', AR: 'Arkansas', CA: 'California', CO: 'Colorado', CT: 'Connecticut', DE: 'Delaware', DC: 'Washington DC', FL: 'Florida', GA: 'Georgia', HI: 'Hawaii', ID: 'Idaho', IL: 'Illinois', IN: 'Indiana', IA: 'Iowa', KS: 'Kansas', KY: 'Kentucky', LA: 'Louisiana', ME: 'Maine', MD: 'Maryland', MA: 'Massachusetts', MI: 'Michigan', MN: 'Minnesota', MS: 'Mississippi', MO: 'Missouri', MT: 'Montana', NE: 'Nebraska', NV: 'Nevada', NH: 'New Hampshire', NJ: 'New Jersey', NM: 'New Mexico', NY: 'New York', NC: 'North Carolina', ND: 'North Dakota', OH: 'Ohio', OK: 'Oklahoma', OR: 'Oregon', PA: 'Pennsylvania', RI: 'Rhode Island', SC: 'South Carolina', SD: 'South Dakota', TN: 'Tennessee', TX: 'Texas', UT: 'Utah', VT: 'Vermont', VA: 'Virginia', WA: 'Washington', WV: 'West Virginia', WI: 'Wisconsin', WY: 'Wyoming' };

    const ESRI = 'https://server.arcgisonline.com/ArcGIS/rest/services/';
    const BASES = [
      ['World_Topo_Map', 'Tiles &copy; Esri &mdash; Esri, HERE, Garmin, FAO, NOAA, USGS, &copy; OpenStreetMap contributors'],
      ['World_Street_Map', 'Tiles &copy; Esri &mdash; Esri, HERE, Garmin, USGS, &copy; OpenStreetMap contributors'],
      ['Canvas/World_Light_Gray_Base', 'Tiles &copy; Esri, HERE, Garmin, &copy; OpenStreetMap contributors'],
    ];

    const isApple = /iPad|iPhone|iPod|Macintosh/.test(navigator.userAgent);
    const esc = (str) => String(str).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    const google = (s) => `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(`${s.name}, ${s.address}`)}`;
    const apple = (s) => `https://maps.apple.com/?daddr=${encodeURIComponent(s.address)}&q=${encodeURIComponent(s.name)}`;
    const miles = (a, b) => {
      const r = (d) => (d * Math.PI) / 180;
      const dLat = r(b[0] - a[0]);
      const dLng = r(b[1] - a[1]);
      const h = Math.sin(dLat / 2) ** 2 + Math.cos(r(a[0])) * Math.cos(r(b[0])) * Math.sin(dLng / 2) ** 2;
      return 3958.8 * 2 * Math.asin(Math.sqrt(h));
    };
    const stateOf = (addr) => {
      const m = String(addr).match(/,\s*([A-Z]{2})\b(?:\s+\d{5})?[^,]*$/) || String(addr).match(/\b([A-Z]{2})\s+\d{5}/);
      return m ? m[1] : '';
    };

    let stores = [];
    let map = null;
    let L = null;
    let layer = null;
    let markers = {};
    let groupOf = {};
    let userMoved = false;
    let quiet = false;
    let lastView = null;
    let pending = null;
    let base = null;

    function countUp(el, to, finalText) {
      if (reduce) { el.textContent = finalText || to; return; }
      const start = performance.now();
      const step = (t) => {
        const p = Math.min(1, (t - start) / 1200);
        el.textContent = Math.round(to * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(step);
        else if (finalText) el.textContent = finalText;
      };
      requestAnimationFrame(step);
    }

    function loadLeaflet() {
      if (window.L) return Promise.resolve(window.L);
      return new Promise((resolve, reject) => {
        const css = document.createElement('link');
        css.rel = 'stylesheet';
        css.href = 'https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/leaflet.css';
        document.head.appendChild(css);
        const js = document.createElement('script');
        js.src = 'https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/leaflet.js';
        js.onload = () => resolve(window.L);
        js.onerror = reject;
        document.head.appendChild(js);
      });
    }

    function useBase(k) {
      if (base) { map.removeLayer(base); base = null; }
      if (k >= BASES.length) return;
      let ok = 0;
      let bad = 0;
      const tiles = L.tileLayer(`${ESRI}${BASES[k][0]}/MapServer/tile/{z}/{y}/{x}`, { maxZoom: 18, attribution: BASES[k][1] });
      tiles.on('tileload', () => { ok += 1; });
      tiles.on('tileerror', () => {
        bad += 1;
        if (base === tiles && !ok && bad >= 3) useBase(k + 1);
      });
      base = tiles;
      tiles.addTo(map);
      root.dataset.base = BASES[k][0];
    }

    function links(s) {
      const first = isApple ? ['Apple Maps', apple(s)] : ['Google Maps', google(s)];
      const second = isApple ? ['Google Maps', google(s)] : ['Apple Maps', apple(s)];
      return `<a class="amb-btn amb-btn--small amb-locator__dir" href="${esc(first[1])}" target="_blank" rel="noopener">Directions</a>
        <a class="amb-link amb-locator__alt" href="${esc(second[1])}" target="_blank" rel="noopener">${second[0]}</a>`;
    }
    const popup = (s) => `<span class="amb-locator__popname">${esc(s.name)}</span><span class="amb-locator__popaddr">${esc(s.address)}</span><span class="amb-locator__pop">${links(s)}</span>`;
    const dist = (d) => (d < 10 ? d.toFixed(1) : Math.round(d).toLocaleString('en-US')) + ' mi';

    function render(list, label) {
      listEl.innerHTML = list.map((s, n) => `
        <li class="amb-locator__item" data-i="${s.i}" style="--n:${Math.min(n, 12)};--c:${s.c}">
          <button type="button" class="amb-locator__pick" data-i="${s.i}">
            <span class="amb-locator__name"><span class="amb-locator__dot" aria-hidden="true"></span>${esc(s.name)}</span>
            <span class="amb-locator__addr">${esc(s.address)}</span>
          </button>
          ${s.d != null ? `<span class="amb-locator__dist">${dist(s.d)}</span>` : ''}
          <div class="amb-locator__links">${links(s)}</div>
        </li>`).join('');
      statusEl.textContent = label || (fixedNum ? `${list.length} shops on the map` : `All ${list.length} shops`);
      listEl.classList.remove('is-fresh');
      void listEl.offsetWidth;
      listEl.classList.add('is-fresh');
      listEl.scrollTop = 0;
    }

    function hot(i, on) {
      const m = markers[i] || groupOf[i];
      const el = m && m.getElement();
      if (el) el.classList.toggle('is-hot', on);
      if (m) m.setZIndexOffset(on ? 1000 : 0);
    }

    function mark(i) {
      listEl.querySelectorAll('.amb-locator__item').forEach((li) => li.classList.toggle('is-active', Number(li.dataset.i) === i));
    }

    function move(fn) {
      quiet = true;
      fn();
      setTimeout(() => { quiet = false; }, 900);
    }

    function focus(i) {
      const s = stores[i];
      mark(i);
      if (!map) return;
      move(() => map.flyTo([s.lat, s.lng], Math.max(map.getZoom(), 12), { duration: reduce ? 0 : 0.7 }));
      setTimeout(() => { if (markers[i]) markers[i].openPopup(); }, reduce ? 50 : 800);
    }

    function sortFrom(point, label, fit = true) {
      const sorted = stores.map((s) => ({ ...s, d: miles(point, [s.lat, s.lng]) })).sort((a, b) => a.d - b.d);
      render(sorted, label);
      pending = fit ? [point, ...sorted.slice(0, 5).map((s) => [s.lat, s.lng])] : null;
      if (map && fit) {
        const near = sorted.slice(0, 5).map((s) => [s.lat, s.lng]);
        move(() => map.fitBounds(L.latLngBounds([point, ...near]).pad(0.25), { maxZoom: 11, animate: !reduce }));
      }
      resetBtn.hidden = false;
    }

    function filterText(q, fit) {
      const t = q.toLowerCase();
      const hits = stores.filter((s) => `${s.name} ${s.address} ${STATES[s.st] || ''}`.toLowerCase().includes(t));
      if (!hits.length) return 0;
      render(hits, `${hits.length} ${hits.length === 1 ? 'shop matches' : 'shops match'} “${q}”`);
      if (map && fit) move(() => map.fitBounds(L.latLngBounds(hits.map((s) => [s.lat, s.lng])).pad(0.3), { maxZoom: 12, animate: !reduce }));
      resetBtn.hidden = false;
      return hits.length;
    }

    function showAll() {
      input.value = '';
      userMoved = false;
      stateSel.value = '';
      render(stores);
      if (map) move(() => map.fitBounds(L.latLngBounds(stores.map((s) => [s.lat, s.lng])).pad(0.08), { animate: !reduce }));
      resetBtn.hidden = true;
    }

    async function geocode(q) {
      const url = `https://nominatim.openstreetmap.org/search?format=json&countrycodes=us&limit=1&q=${encodeURIComponent(q)}`;
      const res = await fetch(url, { headers: { Accept: 'application/json' } });
      const json = await res.json();
      return json && json[0] ? [Number(json[0].lat), Number(json[0].lon)] : null;
    }

    function states() {
      const counts = {};
      stores.forEach((s) => { if (s.st) counts[s.st] = (counts[s.st] || 0) + 1; });
      const all = Object.entries(counts).sort((a, b) => (STATES[a[0]] || a[0]).localeCompare(STATES[b[0]] || b[0]));
      statesEl.dataset.n = all.length;
      stateSel.innerHTML = '<option value="">Browse by state</option>' + all.map(([st, n]) =>
        `<option value="${st}">${esc(STATES[st] || st)} (${n})</option>`).join('');
    }

    stateSel.addEventListener('change', () => {
      const st = stateSel.value;
      if (!st) { showAll(); return; }
      const hits = stores.filter((s) => s.st === st);
      render(hits, `${hits.length} ${hits.length === 1 ? 'shop' : 'shops'} in ${STATES[st] || st}`);
      resetBtn.hidden = false;
      if (map) move(() => map.fitBounds(L.latLngBounds(hits.map((s) => [s.lat, s.lng])).pad(0.2), { maxZoom: 11, animate: !reduce }));
      root.querySelector('.amb-locator__panel').scrollIntoView({ block: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
    });

    listEl.addEventListener('click', (e) => {
      const pick = e.target.closest('.amb-locator__pick');
      if (pick) focus(Number(pick.dataset.i));
    });
    listEl.addEventListener('pointerover', (e) => {
      const li = e.target.closest('.amb-locator__item');
      if (li) hot(Number(li.dataset.i), true);
    });
    listEl.addEventListener('pointerout', (e) => {
      const li = e.target.closest('.amb-locator__item');
      if (li && !li.contains(e.relatedTarget)) hot(Number(li.dataset.i), false);
    });

    let typing = 0;
    input.addEventListener('input', () => {
      clearTimeout(typing);
      typing = setTimeout(() => {
        const q = input.value.trim();
        if (!q) { showAll(); return; }
        if (q.length >= 2 && !/^\d+$/.test(q)) filterText(q, true);
      }, 220);
    });

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      clearTimeout(typing);
      const q = input.value.trim();
      if (!q) { showAll(); return; }
      statusEl.textContent = 'Searching';
      try {
        const hit = await geocode(q);
        if (hit) { sortFrom(hit, `Closest to ${q}`); return; }
      } catch (err) {}
      if (!filterText(q, true)) statusEl.textContent = `Nothing found for “${q}”. Try a city or ZIP.`;
    });

    nearBtn.addEventListener('click', () => {
      if (!navigator.geolocation) return;
      statusEl.textContent = 'Finding your location';
      navigator.geolocation.getCurrentPosition(
        (pos) => sortFrom([pos.coords.latitude, pos.coords.longitude], 'Closest to you'),
        () => { statusEl.textContent = 'We could not get your location. Try a city or ZIP.'; },
        { timeout: 8000 }
      );
    });
    resetBtn.addEventListener('click', showAll);

    async function autoLocate() {
      if (root.dataset.auto !== '1') return;
      try {
        if (navigator.permissions && navigator.geolocation) {
          const p = await navigator.permissions.query({ name: 'geolocation' });
          if (p.state === 'granted') {
            navigator.geolocation.getCurrentPosition((pos) => {
              if (!userMoved && !input.value) sortFrom([pos.coords.latitude, pos.coords.longitude], 'Closest to you');
            }, () => {}, { timeout: 6000, maximumAge: 600000 });
            return;
          }
        }
      } catch (err) {}
      try {
        const ctl = new AbortController();
        setTimeout(() => ctl.abort(), 4000);
        const geo = await (await fetch('https://get.geojs.io/v1/ip/geo.json', { signal: ctl.signal })).json();
        const lat = Number(geo.latitude);
        const lng = Number(geo.longitude);
        if (geo.country_code !== 'US' || !isFinite(lat) || userMoved || input.value) return;
        const place = [geo.city, geo.region].filter(Boolean).join(', ');
        sortFrom([lat, lng], place ? `Closest to ${place}` : 'Closest to you');
      } catch (err) {}
    }

    function mapMoved() {
      if (quiet || !map) return;
      userMoved = true;
      const c = map.getCenter();
      const b = map.getBounds();
      const inView = stores.filter((s) => b.contains([s.lat, s.lng])).length;
      const sorted = stores.map((s) => ({ ...s, d: miles([c.lat, c.lng], [s.lat, s.lng]) })).sort((a, z) => a.d - z.d);
      const key = `${c.lat.toFixed(2)},${c.lng.toFixed(2)},${map.getZoom()}`;
      if (key === lastView) return;
      lastView = key;
      render(sorted, inView ? `${inView} ${inView === 1 ? 'shop' : 'shops'} in this area` : 'Closest to the map center');
      resetBtn.hidden = false;
      hintEl.classList.add('is-gone');
    }

    // Pin: a tiny linen bag, its zipper in the shop's color, with the woven tag.
    const bag = (c) => `<svg viewBox="0 0 34 30" aria-hidden="true"><path class="b" d="M5 10.5C5 6 8.5 4 17 4s12 2 12 6.5l-1 11.5c-.3 3-3.5 4.5-11 4.5s-10.7-1.5-11-4.5z"/><path class="z" d="M5.6 10.5c4 3 18.8 3 22.8 0" style="stroke:${c}"/><rect class="t" x="1" y="12" width="6" height="3.4" rx=".6"/><path class="s" d="M9 23.5c4 1.2 12 1.2 16 0"/></svg>`;

    // On-screen grouping at the current zoom. Shops start as dots; any two
    // markers whose circles would overlap merge into one green bubble, and this
    // repeats until nothing overlaps. A lone dot with room around it becomes a
    // full bag pin.
    const DOT_R = 9;
    const BAG_R = 17;
    const sizeOf = (n) => Math.round(28 + Math.min(20, Math.sqrt(n) * 4));
    const radius = (g) => (g.ids.length === 1 ? DOT_R : sizeOf(g.ids.length) / 2);
    function layout() {
      const z = map.getZoom();
      let gs = stores.map((s) => ({ ids: [s.i], p: map.project([s.lat, s.lng], z) }));
      let merged = true;
      while (merged) {
        merged = false;
        for (let a = 0; a < gs.length && !merged; a += 1) {
          for (let b = a + 1; b < gs.length; b += 1) {
            if (gs[a].p.distanceTo(gs[b].p) < radius(gs[a]) + radius(gs[b]) + 3) {
              const A = gs[a].ids.length;
              const B = gs[b].ids.length;
              gs[a] = { ids: gs[a].ids.concat(gs[b].ids), p: gs[a].p.multiplyBy(A).add(gs[b].p.multiplyBy(B)).divideBy(A + B) };
              gs.splice(b, 1);
              merged = true;
              break;
            }
          }
        }
      }
      gs.forEach((g) => {
        if (g.ids.length > 1) { g.kind = 'group'; return; }
        const roomy = gs.every((o) => o === g || g.p.distanceTo(o.p) > BAG_R + (o.ids.length === 1 ? BAG_R : radius(o)) + 2);
        g.kind = roomy ? 'bag' : 'dot';
      });
      return gs;
    }

    function shop(i, kind) {
      const s = stores[i];
      const icon = kind === 'bag'
        ? L.divIcon({ className: 'amb-locator__pin', html: `<span>${bag(s.c)}</span>`, iconSize: [34, 30], iconAnchor: [17, 27], popupAnchor: [0, -24] })
        : L.divIcon({ className: 'amb-locator__pin amb-locator__pin--dot', html: '<span class="amb-locator__dotpin"></span>', iconSize: [16, 16], iconAnchor: [8, 8], popupAnchor: [0, -8] });
      const m = L.marker([s.lat, s.lng], { icon, title: s.name, riseOnHover: true })
        .bindPopup(popup(s), { className: 'amb-locator__popup', maxWidth: 260 })
        .on('click', () => {
          mark(i);
          const li = listEl.querySelector(`.amb-locator__item[data-i="${i}"]`);
          if (li) li.scrollIntoView({ block: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
        });
      layer.addLayer(m);
      markers[i] = m;
    }

    function bubble(ids, at) {
      const n = ids.length;
      const size = sizeOf(n);
      const bounds = L.latLngBounds(ids.map((i) => [stores[i].lat, stores[i].lng]));
      const m = L.marker(map.unproject(at, map.getZoom()), {
        icon: L.divIcon({ className: 'amb-locator__pin amb-locator__pin--group', html: `<span class="amb-locator__group" style="--s:${size}px">${n}</span>`, iconSize: [size, size], iconAnchor: [size / 2, size / 2] }),
        title: `${n} shops`,
        keyboard: true,
      }).on('click', () => {
        const target = map.getBoundsZoom(bounds.pad(0.4));
        if (target > map.getZoom() && bounds.getNorthEast().distanceTo(bounds.getSouthWest()) > 50) {
          map.fitBounds(bounds.pad(0.4), { animate: !reduce });
        } else {
          map.setView(bounds.getCenter(), Math.min(map.getZoom() + 3, 18), { animate: !reduce });
        }
      });
      layer.addLayer(m);
      ids.forEach((i) => { groupOf[i] = m; });
    }

    function drawPins() {
      if (!map) return;
      if (layer) layer.clearLayers(); else layer = L.layerGroup().addTo(map);
      markers = {};
      groupOf = {};
      layout().forEach((g) => {
        if (g.kind === 'group') bubble(g.ids, g.p);
        else shop(g.ids[0], g.kind);
      });
      const first = !root.dataset.dropped;
      layer.eachLayer((m) => {
        const el = m.getElement();
        if (!el) return;
        if (first) el.style.setProperty('--d', `${reduce ? 0 : Math.round(Math.random() * 700)}ms`);
        else el.classList.add('is-in', 'is-still');
      });
    }

    function dropPins() {
      if (!map || root.dataset.dropped) return;
      root.dataset.dropped = '1';
      layer.eachLayer((m) => m.getElement() && m.getElement().classList.add('is-in'));
    }

    (async () => {
      try {
        const raw = await (await fetch(root.dataset.src)).json();
        stores = raw.map((r, i) => ({ i, name: r[0], address: r[1], lat: r[2], lng: r[3], st: stateOf(r[1]), c: PALETTE[i % PALETTE.length] }));
        render(stores);
        states();
        new IntersectionObserver((entries, io) => {
          if (!entries[0].isIntersecting) return;
          io.disconnect();
          if (fixedNum) countUp(totalEl, fixedNum, fixedTotal);
          else countUp(totalEl, stores.length);
          countUp(statesEl, Number(statesEl.dataset.n || 0));
        }).observe(totalEl);
        autoLocate();

        L = await loadLeaflet();
        map = L.map(mapEl, { scrollWheelZoom: false, zoomControl: true, zoomSnap: 0.25 });
        map.fitBounds(L.latLngBounds(stores.map((s) => [s.lat, s.lng])).pad(0.08));
        useBase(0);
        if (pending) map.fitBounds(L.latLngBounds(pending).pad(0.25), { maxZoom: 11, animate: false });
        drawPins();

        map.on('zoomend', drawPins);
        map.on('moveend', mapMoved);
        mapEl.addEventListener('click', () => map.scrollWheelZoom.enable(), { once: true });
        if ('ResizeObserver' in window) new ResizeObserver(() => map.invalidateSize()).observe(mapEl);
        new IntersectionObserver((entries, io) => {
          if (!entries[0].isIntersecting) return;
          io.disconnect();
          map.invalidateSize();
          dropPins();
        }, { threshold: 0.25 }).observe(mapEl);
      } catch (err) {
        statusEl.textContent = 'The map could not load. The list still works.';
      }
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amb-material"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Zig-zag: each benefit drops in as it scrolls into view. Only hidden
    // once the script is running, so they always show without it.
    const setup = (root) => {
      if (!root.classList.contains('amb-why--zig') || root.dataset.zigReady) return;
      root.dataset.zigReady = '1';
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
      const cards = root.querySelectorAll('.amb-why__card');
      root.classList.add('is-armed');
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        });
      }, { threshold: 0.35, rootMargin: '0px 0px -8% 0px' });
      cards.forEach((c) => io.observe(c));
    };
    const boot = () => document.querySelectorAll('[data-amb-why]').forEach(setup);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amb-natural"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Opening a produce type crossfades the photo to that bag; closing it
    // returns to the main photo. Notes float in when the photo is in view.
    const setup = (root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      const media = root.querySelector('[data-amb-natural-media]');
      const imgs = [...root.querySelectorAll('.amb-natural__img')];
      const frame = root.querySelector('.amb-natural__frame');
      const svg = root.querySelector('[data-amb-natural-lines]');
      const groups = [...root.querySelectorAll('.amb-natural__notes')];
      const NS = 'http://www.w3.org/2000/svg';
      let activeKey = 'base';

      // Each photo has its own set of notes. A produce type with no notes of
      // its own falls back to the main photo's notes.
      const groupFor = (key) => groups.find((g) => g.dataset.key === key) || groups.find((g) => g.dataset.key === 'base');

      // Draw a fine line from each note to its spot on the bag, mapped
      // through the photo's crop so it lands right at every screen size.
      const drawLines = (animate) => {
        if (!frame || !svg) return;
        const group = groupFor(activeKey);
        const allNotes = group ? [...group.querySelectorAll('.amb-natural__note')] : [];
        const list = allNotes.map((n) => (n.dataset.px ? [parseFloat(n.dataset.px), parseFloat(n.dataset.py)] : null));
        const box = imgs.find((i) => i.dataset.key === activeKey);
        const img = box && box.querySelector('img');
        const any = list.some(Boolean);
        frame.classList.toggle('show-points', !!(any && img));
        if (!any || !img || !img.naturalWidth) { if (!any) svg.innerHTML = ''; return; }
        const fw = frame.clientWidth, fh = frame.clientHeight;
        const k = Math.max(fw / img.naturalWidth, fh / img.naturalHeight);
        const iw = img.naturalWidth * k, ih = img.naturalHeight * k;
        const ox = (fw - iw) / 2, oy = (fh - ih) / 2;
        const fr = frame.getBoundingClientRect();
        svg.setAttribute('viewBox', `0 0 ${fw} ${fh}`);
        svg.innerHTML = '';
        allNotes.forEach((note, n) => {
          const sp = list[n];
          if (!sp) return;
          const tx = ox + (sp[0] / 100) * iw;
          const ty = oy + (sp[1] / 100) * ih;
          const r = note.getBoundingClientRect();
          const l = r.left - fr.left, t = r.top - fr.top, w = r.width, h = r.height;
          let sx, sy;
          if (ty > t + h) { sx = Math.min(Math.max(tx, l + 18), l + w - 18); sy = t + h; }
          else if (ty < t) { sx = Math.min(Math.max(tx, l + 18), l + w - 18); sy = t; }
          else { sx = tx > l + w / 2 ? l + w : l; sy = t + h / 2; }
          const mx = (sx + tx) / 2, my = Math.min(sy, ty);
          const path = document.createElementNS(NS, 'path');
          path.setAttribute('d', `M${sx.toFixed(1)} ${sy.toFixed(1)} Q${mx.toFixed(1)} ${my.toFixed(1)} ${tx.toFixed(1)} ${ty.toFixed(1)}`);
          path.setAttribute('class', 'amb-natural__line');
          path.style.setProperty('--i', n);
          const ring = document.createElementNS(NS, 'circle');
          ring.setAttribute('cx', tx.toFixed(1)); ring.setAttribute('cy', ty.toFixed(1)); ring.setAttribute('r', '9');
          ring.setAttribute('class', 'amb-natural__ring');
          ring.style.setProperty('--i', n);
          const dot = document.createElementNS(NS, 'circle');
          dot.setAttribute('cx', tx.toFixed(1)); dot.setAttribute('cy', ty.toFixed(1)); dot.setAttribute('r', '4.5');
          dot.setAttribute('class', 'amb-natural__spot');
          dot.style.setProperty('--i', n);
          svg.appendChild(path); svg.appendChild(ring); svg.appendChild(dot);
          const len = path.getTotalLength();
          path.style.strokeDasharray = len;
          path.style.setProperty('--len', len);
          if (animate === true && root.classList.contains('is-in')) {
            path.style.transition = 'none';
            path.style.strokeDashoffset = len;
            requestAnimationFrame(() => requestAnimationFrame(() => {
              path.style.transition = `stroke-dashoffset 0.8s cubic-bezier(0.45, 0, 0.25, 1) ${150 + n * 120}ms`;
              path.style.strokeDashoffset = 0;
            }));
          }
        });
      };

      const show = (key) => {
        const target = imgs.find((i) => i.dataset.key === key) || imgs.find((i) => i.dataset.key === 'base') || imgs[0];
        imgs.forEach((i) => i.classList.toggle('is-on', i === target));
        activeKey = target ? target.dataset.key : 'base';
        const group = groupFor(activeKey);
        groups.forEach((g) => g.classList.toggle('is-on', g === group));
        const img = target && target.querySelector('img');
        if (img && !img.complete) img.addEventListener('load', () => drawLines(true), { once: true });
        drawLines(true);
      };

      if (frame) {
        if ('ResizeObserver' in window) new ResizeObserver(() => drawLines()).observe(frame);
        window.addEventListener('resize', () => drawLines());
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => drawLines());
      }
      root.querySelectorAll('.amb-natural__item').forEach((d) => {
        d.addEventListener('toggle', () => {
          const open = root.querySelector('.amb-natural__item[open]');
          show(open ? open.dataset.key : 'base');
        });
      });
      // Theme editor: picking a produce type in the sidebar opens it, so its
      // photo and notes show while you edit them.
      root.addEventListener('shopify:block:select', (e) => {
        const d = e.target.closest && e.target.closest('.amb-natural__item');
        if (d && !d.open) d.open = true;
      });
      const open = root.querySelector('.amb-natural__item[open]');
      show(open ? open.dataset.key : 'base');
      if (!media || !('IntersectionObserver' in window)) { root.classList.add('is-in'); drawLines(); return; }
      const io = new IntersectionObserver((entries) => entries.forEach((e) => {
        if (e.isIntersecting) { root.classList.add('is-in'); io.disconnect(); setTimeout(() => drawLines(), 1400); }
      }), { threshold: 0.3 });
      io.observe(media);
    };
    const boot = () => document.querySelectorAll('[data-amb-natural]').forEach(setup);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amb-quotes"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Review cards: arrows scroll the row one card at a time and switch off at the ends.
    const boot = () => {
      document.querySelectorAll('[data-amb-rcards]:not([data-ready])').forEach((wrap) => {
        wrap.dataset.ready = '1';
        const rail = wrap.querySelector('[data-amb-rcards-rail]');
        const section = wrap.closest('.amb-quotes');
        const prev = section.querySelector('[data-amb-rcards-prev]');
        const next = section.querySelector('[data-amb-rcards-next]');
        if (!rail || !prev || !next) return;
        const step = () => {
          const card = rail.querySelector('.amb-rcard');
          const gap = parseFloat(getComputedStyle(rail).columnGap) || 16;
          return card ? card.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
        };
        const sync = () => {
          const max = rail.scrollWidth - rail.clientWidth - 2;
          prev.disabled = rail.scrollLeft <= 2;
          next.disabled = rail.scrollLeft >= max;
          section.classList.toggle('amb-quotes--fits', max <= 0);
        };
        prev.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
        next.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
        rail.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
        window.addEventListener('resize', sync);
        sync();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amb-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.addEventListener('click', (event) => {
      const btn = event.target instanceof Element ? event.target.closest('[data-amb-story-sound]') : null;
      if (!btn) return;
      const video = btn.parentElement.querySelector('video');
      if (!video) return;
      const on = btn.getAttribute('aria-pressed') !== 'true';
      video.muted = !on;
      if (on) { video.currentTime = 0; video.play().catch(() => {}); }
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      const label = btn.querySelector('[data-amb-story-sound-label]');
      if (label) label.textContent = on ? 'Sound off' : "Hear Jan's story";
    });
    // Snapshots and the quote ease in as the letter scrolls past.
    const boot = () => {
      const els = document.querySelectorAll('.amb-story__snap, .amb-story__quote');
      if (!('IntersectionObserver' in window)) { els.forEach((e) => e.classList.add('is-in')); return; }
      const io = new IntersectionObserver((entries) => entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      }), { threshold: 0.25 });
      els.forEach((e) => io.observe(e));
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amb-timeline"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.ambTl) return;
      root.dataset.ambTl = '1';
      var list = root.querySelector('.amb-tl__list');
      var items = [].slice.call(root.querySelectorAll('.amb-tl__item'));
      if (!list || !items.length) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        list.style.setProperty('--p', 1);
        items.forEach(function (li) { li.classList.add('is-in'); });
        return;
      }
      root.classList.add('is-live');
      var queued = false;
      function show(li) { li.classList.add('is-in'); }
      function update() {
        queued = false;
        var r = list.getBoundingClientRect();
        var mark = window.innerHeight * 0.7;
        var p = Math.max(0, Math.min(1, (mark - r.top) / (r.height || 1)));
        list.style.setProperty('--p', p.toFixed(4));
        items.forEach(function (li) {
          if (li.getBoundingClientRect().top < mark) show(li);
        });
      }
      // Belt and braces: an observer, and a timed fallback, so a milestone can
      // never stay hidden once it has been on screen.
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) {
          en.forEach(function (e) { if (e.isIntersecting) { show(e.target); io.unobserve(e.target); } });
        }, { rootMargin: '0px 0px -20% 0px' });
        items.forEach(function (li) { io.observe(li); });
      }
      setTimeout(function () {
        items.forEach(function (li) { if (li.getBoundingClientRect().top < window.innerHeight) show(li); });
      }, 2500);
      function ask() { if (!queued) { queued = true; requestAnimationFrame(update); } }
      document.addEventListener('scroll', ask, { capture: true, passive: true });
      window.addEventListener('resize', ask);
      update();
    }
    function boot() { document.querySelectorAll('[data-amb-tl]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amb-usp-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setup = (root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      const track = root.querySelector('.amb-usp__track');
      const cards = [...track.children];
      const dots = [...root.querySelectorAll('.amb-usp__dots button')];
      const prev = root.querySelector('[data-dir="-1"]');
      const next = root.querySelector('[data-dir="1"]');
      if (cards.length < 2) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const step = () => cards[1].offsetLeft - cards[0].offsetLeft;
      const max = () => track.scrollWidth - track.clientWidth;
      const index = () => Math.round(track.scrollLeft / step());
      const go = (i) => track.scrollTo({ left: Math.max(0, Math.min(i * step(), max())), behavior: reduce ? 'auto' : 'smooth' });

      const sync = () => {
        const atEnd = track.scrollLeft >= max() - 4;
        const i = atEnd ? cards.length - 1 : index();
        dots.forEach((d, n) => d.classList.toggle('is-on', n === i));
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = atEnd;
        const scrolls = max() > 4;
        root.classList.toggle('is-static', !scrolls);
      };
      let raf = 0;
      track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
      window.addEventListener('resize', sync, { passive: true });

      let timer = null, stopped = false;
      const stop = () => { stopped = true; clearInterval(timer); };
      const user = (fn) => (e) => { stop(); fn(e); };
      prev && prev.addEventListener('click', user(() => go(index() - 1)));
      next && next.addEventListener('click', user(() => go(index() + 1)));
      dots.forEach((d, n) => d.addEventListener('click', user(() => go(n))));
      track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); stop(); go(index() + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); stop(); go(index() - 1); }
      });
      ['pointerdown', 'wheel', 'touchstart'].forEach((ev) => track.addEventListener(ev, stop, { passive: true }));

      // Desktop: drag to scroll with the mouse.
      let drag = null;
      track.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse') return;
        drag = { x: e.clientX, left: track.scrollLeft, moved: false };
        track.classList.add('is-drag');
      });
      window.addEventListener('pointermove', (e) => {
        if (!drag) return;
        const dx = e.clientX - drag.x;
        if (Math.abs(dx) > 4) drag.moved = true;
        track.scrollLeft = drag.left - dx;
      });
      window.addEventListener('pointerup', () => {
        if (!drag) return;
        track.classList.remove('is-drag');
        if (drag.moved) go(index());
        drag = null;
      });

      const secs = parseFloat(root.dataset.autoplay);
      if (secs && !reduce) {
        let visible = false;
        const tick = () => {
          if (stopped || !visible || document.hidden || root.matches(':hover') || root.contains(document.activeElement)) return;
          track.scrollLeft >= max() - 4 ? go(0) : go(index() + 1);
        };
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(([e]) => { visible = e.isIntersecting; }, { threshold: 0.4 }).observe(track);
        } else visible = true;
        timer = setInterval(tick, secs * 1000);
      }
      sync();
    };
    const boot = () => document.querySelectorAll('[data-amb-usp]').forEach(setup);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amb-wild"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Load each clip as it nears the screen, play it while it is on screen,
    // and pause it when it scrolls away.
    const load = (v) => { if (v.dataset.src && !v.src) { v.src = v.dataset.src; v.preload = 'auto'; } };
    const play = (v) => { load(v); v.play().catch(() => {}); };
    const boot = () => {
      const vids = [...document.querySelectorAll('.amb-wild__video[data-src]:not([data-amb-wild])')];
      if (!vids.length) return;
      vids.forEach((v) => { v.dataset.ambWild = '1'; });
      if (!('IntersectionObserver' in window)) { vids.forEach(play); return; }
      const near = new IntersectionObserver((en) => {
        en.forEach((e) => { if (e.isIntersecting) { load(e.target); near.unobserve(e.target); } });
      }, { rootMargin: '600px 0px' });
      const seen = new IntersectionObserver((en) => {
        en.forEach((e) => { if (e.isIntersecting) play(e.target); else if (!e.target.paused) e.target.pause(); });
      }, { threshold: 0.2 });
      vids.forEach((v) => { near.observe(v); seen.observe(v); });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  document.addEventListener('click', (event) => {
    const btn = event.target instanceof Element ? event.target.closest('[data-amb-sound]') : null;
    if (!btn) return;
    const video = btn.parentElement.querySelector('video');
    if (!video) return;
    const on = btn.getAttribute('aria-pressed') !== 'true';
    document.querySelectorAll('.amb-wild__video').forEach((v) => { v.muted = true; });
    document.querySelectorAll('[data-amb-sound]').forEach((b) => b.setAttribute('aria-pressed', 'false'));
    video.muted = !on;
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    if (on) { if (!video.src && video.dataset.src) video.src = video.dataset.src; video.currentTime = 0; video.play().catch(() => {}); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
